/**
 * Created by leon on 17/7/18.
 */

'use strict';

exports.__esModule = true;
exports.default = {
  nav: {
    mmp: 'Shop Management Platform',
    index: 'Home',
    settlement: 'Settlement Mgmt',
    tradeMng: 'Transaction Mgmt',
    tradeAssign: 'Trading Flow',
    refundCheck: ' Refund Review',
    shopMng: 'Account Info',
    cashMng: 'Cashier Mgmt',
    setup: 'Settings',
    passSet: 'Mgmt Pass Settings',
    emailSet: 'Email Settings',
    contact: 'Contact Us',
    termsAndEnquiries: 'Terms & Enquiries',
    terms: 'Terms & Conditions',
    termsContent: 'By using QFPay payment services, you agree to the terms and conditions listed in the link below. If you do not agree to these terms, you may not use the payment service provided by QFPay.',
    termsLink: 'http://merchanttnc.s3-website-ap-southeast-1.amazonaws.com/',
    device: 'Device Binding',
    partnerAccountSetting: 'Partner Account',
    functionSettings: 'Function Settings',
    remotePay: 'RemotePay',
    linkManage: 'Link Mgmt',
    orderManage: 'Order Mgmt'
  },
  common: {
    ok: 'OK',
    cancel: 'Cancel',
    close: 'Close',
    confirm: 'Confirm',
    tip: 'Tips',
    all: 'All',
    none: 'Nothing',
    netError: 'Net error',
    loading: 'Loading...',
    modSucc: 'Modified successfully',
    modFailed: 'Failed to modify',
    logout: 'Logout',
    del: 'Delete',
    export: 'Export',
    msg: {
      sel: 'Please choose'
    }
  },
  time: {
    today: 'Today',
    yesterday: 'Yesterday',
    near7: 'Last 7 days',
    near30: 'Last 30 days',
    nearMonth: 'Last month',
    nearDay: 'This month',
    near365: 'Last 1 year',
  },
  main: {
    bigMerchant: 'Enterprise',
    merchant: 'Single store',
    subMerchant: 'Branch',
    cashier: 'Cashier'
  },
  shopmng: { // 门店管理模块
    crumbs: {
      L1: 'Account Info'
    },
    title: {
      baseInfo: 'Basic Information',
      subInfo: 'Branch Information'
    },
    panel: {
      shopName: 'Shop Name',
      loginAccount: 'Account',
      mID: 'MID',
      btn: {
        editPwd: 'Change Password',
        editSub: 'Edit Branch Shop',
        editSubTag: 'Edit Customized ID',
        down: 'Shop QR Code',
        listDown: 'Download store QR code'
      },
      table: {
        subName: 'Branch Name',
        loginAccount: 'Account',
        regTime: 'Register Time',
        sID: 'SID',
        subTag: 'Customized ID',
        op: 'Operation',
        detail: 'Details',
        more: 'More',
        editPwd: 'Change Password',
        delSub: 'Delete Branch Shop'
      }
    },
    dialog: {
      editPwd: 'Change Password',
      loginAccount: 'Account',
      inputNewPwd: 'New PWD',
      confirmNewPwd: 'Confirm',
      msg: {
        m1: 'Please enter a new password.',
        m2: 'Please confirm the new password.',
        m3: 'The new password and the confirmation don’t match.',
        m4: 'Enter alphabets or numbers from 6 to 20 digits.',
        m5: 'Please enter password of master account.', // 请输入总账户密码
        m6: 'Please enter branch account.', // 请输入分店账号
        m7: 'Please enter password of branch account.',
        m8: 'Please enter branch account owner name.',
        m9: 'Please enter branch bank account!',
        m10: 'Alphabets or numbers within 20 digits.',
        m11: 'No special characters.',
        m12: 'Incorrect Password.',
        m13: 'Branch Deleted!'
      },
      cancel: 'Cancel',
      ok: 'Confirm',
      confirm: 'Confirm',
      shopDetail: 'Shop Detail Information',
      shopName: 'Shop Name',
      address: 'Address',
      mobile: 'Phone Number',
      cardHolder: 'Account Owner',
      bankAccount: 'Bank Account',
      bankName: 'Bank Name',
      editSubTag: 'Edit Customized ID',
      diaTip: 'Customized ID would be shown at the exported transaction detail and transaction summary.',
      validateText: 'Please enter charactors within 20',
      validateText2: 'Please enter the login password of master account',
      notice: 'Be Awared!',
      noticeTip: 'Always remember to turn off the branch shop promotions before delete the branch.',
      downTip: 'Select the store name where you want to download：',
      nullTip: 'Please select at least one branch',
      all: 'Select all'
    }
  },
  tradeMng: { // 交易流水
    crumbs: {
      L1: 'Transaction Management',
      L2: 'Transaction detail',
      L3: 'Refund detail',
      L4: 'Trading Flow',
    },
    panel: {
      time: 'Time Range',
      range: 'select date range',
      shopName: 'Store Name',
      operator: 'Cashier',
      moreFilter: 'More Options',
      noLimit: 'All',
      dd: 'Refund', // 撤销明细
      sNum: 'Transaction ID', // 流水号
      tip: 'Please enter the transaction ID',
      tip1: 'Please enter the shop name',
      chnlsn: 'External Order ID',
      lastevent: 'Last Event',
      cardScheme: 'Card Scheme',
      btn: {
        query: 'Search',
        advancedSearch: 'Advanced Search',
        reset: 'Reset'
      }
    },
    table: {
      totalAmount: 'Total Amount',
      totalNum: 'Total Number',
      succAmount: 'Success Amount',
      succ: 'Success Number',
      refundMount: 'Refund Amount',
      refundNum: 'Refund Number',
      bi: 'times',
      undo: 'Refund The Details',
      shopName: 'Store Name',
      operator: 'Cashier',
      all: 'All',
      main: 'Merchant Account',
      colWay: 'Transaction Type',
      wechatCollect: 'Collect by Wechat',
      alipay: 'Alipay',
      tradeType: 'Transaction Type',
      tradeTime: 'Transaction Time',
      tradeAmount: 'Transaction Amount',
      originAmount: 'Receivables',
      currency: 'Currency',
      tradeState: 'Transaction Status',
      redpacket: 'Red Envelope Discount', // 红包优惠
      sNum: 'Transaction ID',
      chnlsn: 'External Order ID',
      merchantOrder: 'Merchant Order ID',
      customerId: 'Consumer ID',
      src: 'Consumer Source',
      cardCd: 'Bank card No.',
      remark: 'Remark',
      op: 'Operation',
      cancel: 'Refund',
      down: 'Download',
      more: 'More',
      detail: 'Details',
      download: 'Download Receipt',
      ac: 'Actually Collected', // 实收
      red: 'paid from the red envelope', // 商家红包
      plat: 'paid from the platform', // 平台补贴
      cardNumber: 'Card Number',
      cardScheme: 'Card Scheme',
      cardType: 'Card Type',
      cardArea: 'Card Area',
      btn: {
        downDetail: 'Download The Transaction Details',
        downTrade: 'Download The Transaction Summary'
      },
      tip: {
        m1: 'Transaction ID generated by QFPay',
        m2: 'Order ID generated by acquiring institutions (e.g. Alipay/Wechat Pay/UnionPay, etc.)',
        m3: 'Reference number generated by merchant internal system (if applicable)',
        m4: 'Total amount of successful payment transactions (refund not deducted)',
        m5: 'Total number of successful payment transactions (refund not deducted)',
        m6: 'Total amount of refund transactions',
        m7: 'Total number of refund transactions'
      }
    },
    detail: {
      amount1: 'Transaction amount',
      amount2: 'Refund amount',
      origin: 'Source of consumers',
      time: 'Refund time',
      syssn1: 'Transaction ID',
      syssn2: 'Original ID',
      syssn3: 'Refund ID',
      store: 'Store name',
      account: 'Operating Account',
      refundApplicationSource: 'Refund Application Source',
      history: 'Refund History',
      amount3: 'Actual Amounts',
      count1: 'Actual Quantity',
      count2: 'Order Quantity',
      syssn4: 'Chain Order No.'
    },
    dialog: {
      d1: 'This action cannot be undone, do you want to refund?',
      d2: 'Confirm',
      d3: 'Success',
      d4: 'Fail',
      d5: 'Password',
      d6: 'refund',
      d7: 'The refund is in progress.',
      d8: 'Apply for refund',
      d9: 'Submitted for approval',
      refundAmount: 'Refund Amount:',
      approvalType: 'Type:',
    },
    msg: {
      m1: 'Transaction ID must be figures!',
      m2: 'At least 14 digits are necessary for the payment Transaction ID!',
      m3: 'Failed to get the payment list at the first time.',
      m4: 'Failed to get the payment data.',
      m5: 'Failed to get the cashier information.',
      m6: 'Successfully refunded.',
      m7: 'Failed to refund.',
      m8: 'Please enter the Transaction ID.',
      m9: "Please enter the account's password.",
      m10: 'invalidate password.',
      m11: 'You don’t have the authority to proceed.',
      m12: 'Out of range',
      m13: 'Refund failed, please contact us for assistance.',
      m14: 'Max. Refund Amount',
      m15: 'Please enter the refund amount',
      m16: 'Please enter a valid refund amount',
      m17: 'Please input external order ID',
      m18: 'Please input merchant order ID'
    }
  },
  refundCheck: { // 退款审核
    crumbs: {
      L1: 'Transaction Management',
      L2: 'Refund Review'
    },
    panel: {
      time: 'Application time',
      shopName: 'Store name',
      operator: 'Cashier',
      oNUm: 'Original ID',
      tip: 'Please enter the Original ID',
      btn: {
        query: 'Search',
        reset: 'Reset'
      }
    },
    table: {
      applyAmount: 'Account Application',
      tradeType: 'Type',
      tradeTime: 'Time',
      refundMount: 'Refund amount',
      tradeAmount: 'Amount',
      sNum: 'Transaction ID',
      checkState: 'Approval Status',
      waiting: 'Moderated',
      underReview: 'Under Review',
      approved: 'Approved',
      rejected: 'Rejected',
      refundSuccessfully: 'Refund Successfully',
      refundFailed: 'Refund Failed',
      refundInProgress: 'Refund In Progress',
      op: 'Operation',
      approve: 'Approve',
      reject: 'Refuse',
      refundApplicationSource: 'Refund Application Source',
      ims: 'IMS',
      mms: 'MMS',
      haoJin: 'haojin APP'
    },
    dialog: {
      d1: 'The operation will not be withdrawn once confirmed, whether approved?',
      d2: 'The operation will not be withdrawn once confirmed, whether refused?',
      d3: 'Confirmation of approval',
      d4: 'Confirm rejection'
    },
    msg: {
      m1: 'Mgmt Pass',
      m2: 'Please enter the Mgmt Pass',
      m3: 'Successful operation',
      m4: 'The refund operation was successful and waiting for the payment channel to be processed.'
    }
  },
  home: { // 首页概览
    crumbs: {
      L1: 'Home'
    },
    title: {
      t1: 'Payment Statistics',
      t2: 'Trading chart'
    },
    panel: {
      t1: 'New Customers Today',
      t2: 'Daily Statistics',
      tc: 'Returning Customer Today',
      cmnew: 'New Customers This Month',
      cumulativeMembership: 'Total Customers',
      tta: '# of Transactions',
      tincome: 'Total Received (Day)',
      cmincome: 'Total Received (Month)',
      noActivity: 'No Promotion'
    },
    chart: {
      bill: 'Count',
      noTrans: 'No transaction',
      account: 'Net Amount',
      time: 'Time',
      sum: 'Amount',
      tp1: 'Only support queries for 30 days'
    }
  },
  settlement: { // 清算管理
    crumbs: {
      L1: 'Settlement Mgmt'
    },
    panel: {
      time: 'Time Range',
      type: 'Type',
      btn: {
        query: 'Search',
        reset: 'Reset',
        downAll: 'Download all'
      }
    },
    table: {
      settleTime: 'Settlement Date',
      settleType: 'Settlement Type',
      name: 'Account',
      amount: 'Account Name',
      currency: 'Currency',
      total: 'Total Amount',
      charge: 'Payment Fee',
      settleAmount: 'Settlement Amount',
      op: 'Operation',
      download: 'Download',
      paymentFee: 'Payment Fee',
      refundFee: 'Refund Fee',
      chargebackFee: 'Chargeback Fee',
      adjustmentFee: 'Adjustment Amount'
    },
    msg: {
      m1: 'Fail to get data .',
      m2: 'Only queries for data less than 30 days.',
      m3: 'No data for download.',
      m4: 'No settlement data.'
    },
    tip: {
      m1: 'The payment fee is calculated by multiplying each order by the rate and then rounding up.'
    }
  },
  login: { // 登录页
    head: 'Shop Management Platform',
    reg: 'Login Account',
    user: 'Shop Account',
    cash: 'Cashier No.',
    ltsix: 'More than 6 digits.',
    login: 'Login',
    forgetPwd: 'Forget password?',
    tab1: 'Merchant',
    tab2: 'Cashier',
    msg: {
      m1: 'Please enter the account.',
      m2: 'Please enter the password.',
      m3: 'Failed to log in.',
      m4: 'Enter Shop Account',
      m5: 'Enter Cashier No.',
      m6: 'No account found'
    }
  },
  setting: { // 邮箱设置页
    crumbs: {
      L1: 'Settings',
      L2: 'Email Settings',
      L3: 'Device Binding',
      L4: 'Function Settings',
      L5: 'Partner Account'
    },
    form: {
      account: 'QF Store ID:',
      gateway: 'Payment Gateway:',
      clientID: 'Client ID:',
      clientSecret: 'Client Secret:',
      signingKeyID: 'Signing Key ID:',
      signingKey: 'Signing Key:',
      expiresDate: 'Expires Date:',
      expiresMsg: '*When the key is about to expire, we will send an alert to your contact email address to remind you to update new one from PayMe.',
      shopifyDefaultDomain: 'Shopify Default Domain:',
      apiCredential: 'API Credential:',
      example: 'Example: *.myshopify.com',
      howToGet: 'How to get:  From your Shopify admin, click Settings > Apps and sales channels.',
    },
    gatewayList: {
      online: 'PayMe HSBC online',
      offline: 'PayMe HSBC offline',
      customApp: 'Shopify-Payment Custom Checkout',
    },
    panel: {
      mailSetup: 'Email settings',
      mail: 'Email Address',
      explain: 'A daily payment report will be delivered to this email address every morning at 7 a.m.',
      dailySend: 'Send Daily Report',
      modi: 'Change',
      confirm: 'Confirm',
      amount: 'Store account',
      device: 'Device id'
    },
    btn: {
      query: 'Search',
      reset: 'Reset',
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit'
    },
    table: {
      merchant: 'Company Name',
      shopName: 'Shop name',
      time: 'Binding time',
      close: 'Unbind',
      functionName: 'Function Name',
      note: 'Note',
      status: 'Status',
      functionNameCont: 'Stores Refund Function on Merchant PortalStores Refund Function on Merchant Portal',
      noteCont: 'By turning off this function, all stores under this merchant cannot refund transactions through the transaction details page of the merchant portal; On the contrary, by turning on this function, all stores under this merchant can perform same day refund through the transaction details page of the merchant portal.'
    },
    dialog: {
      d1: 'Add device',
      d2: 'Unbundling device',
      d3: 'Confirm to Disable',
      d4: 'Confirm to Open',
      d5: 'OK',
      d6: 'Cancel',
      d7: 'Are you sure to disable store refund function on merchant portal?',
      d8: 'Are you sure to open store refund function on merchant portal?'
    },
    msg: {
      m1: 'Please enter email address.',
      m2: 'Please enter correct email address.',
      m3: 'Fetch email address failed!',
      m5: 'The email has been added!',
      m6: 'You can only add 10 email addresses',
      m7: 'Do you confirm unbinding?',
      m8: 'Unbind successfully',
      m9: 'Please enter store account.',
      m10: 'Please enter the device number.',
      m11: 'Add success',
      m12: 'On processing.',
      m13: 'Submit success. On processing',
      m14: 'Please input client ID',
      m15: 'Please input client secret',
      m16: 'Please input signing key ID',
      m17: 'Please input signing key',
      m18: 'please select payment gateway',
      m19: 'please input QF store ID',
      m20: 'please select expires date',
      m21: 'Please input Shopify Default Domain',
      m22: 'Please input API Credential',
    },
    tip: {
      m1: 'Delete the last email address will turn off the feature, do you confirm?'
    }

  },
  passSet: { // 管理密码设置
    crumbs: {
      L1: 'Settings',
      L2: 'Manage password settings'
    },
    panel: {
      passMsg: 'Management password：',
      explain: 'Use：After  setting, the refund approval for next day will confirmed entering management password.',
      states1: 'Not set',
      states2: 'Has been set',
      bt1: 'Set',
      bt2: 'Reset',
      bt3: 'Save',
      title1: 'Setting management password',
      title2: 'Reset management password',
      safe: 'Safety verification',
      pass: 'Mgmt Pass',
      reEnter: 'Re-enter',
      originPass: 'Original Mgmt Pass',
      newPass: 'New Mgmt Pass'
    },
    msg: {
      m1: 'Please enter your password',
      m2: 'Please enter your Mgmt Pass',
      m3: 'Please re-enter your Mgmt Pass',
      m4: 'Enter alphabets or numbers from 6 to 20 digits.',
      m6: 'Please enter original Mgmt Pass',
      m7: 'Please enter new Mgmt Pass',
      m8: 'Please re-enter new Mgmt Pass',
      m9: 'Inconsistency with admin password input',
      m10: 'Set successfully'
    },
    tip: {
      m1: 'Forget your original management password？'
    }
  },
  cashMng: { // 收银员管理
    crumbs: {
      L1: 'Cashier Management',
      L2: 'Details',
      L3: 'Add Cashier',
      L4: 'Batch add'
    },
    common: {
      status: 'Status',
      number: 'Cashier No.',
      name: 'Name',
      mobile: 'Phone Number',
      shop: 'Shop Name',
      user: 'Shop Account',
      password: 'Cashier Password',
      m1: 'Account is deactivated',
      m2: 'Account is activated',
      m5: 'Cashier Name',
      m6: 'Cashier Contact',
      m7: 'Cashier Password',
      m8: 'Please enter 2-20 characters',
      m9: 'Please input a valid phone number',
      m10: 'Please enter 6-20 characters',
      tip1: '* Cashier can login with Shop Account, Cashier No. and Cashier Password'
    },
    dialog: {
      title: 'Add cashiers in batches',
      d1: 'Please select the cashier\'s form file',
      d2: 'Select',
      d3: 'Upload',
      d4: 'Down template',
      d5: 'Upload successful'
    },
    mng: {
      status1: 'Active',
      status2: 'Inactive',
      status3: 'Activated',
      status4: 'Deactivated',
      name: 'Cashier Name',
      mobile: 'Cashier Contact',
      op: 'Operation',
      detail: 'Details',
      m5: 'Fail to get cashier’s data',
      open: 'ON',
      close: 'OFF',
      isOpenR: 'Remotepay has been activated',
      isCloseR: 'Remotepay is closed',
    },
    detail: {
      title: 'Cashier Info',
      btn: 'Edit Cashier Info'
    },
    add: {
      title: 'Add Cashier Info',
      tip1: 'One cashier is added',
      tip2: 'Fail to get cashier’s number',
      btn1: 'Cancel',
      btn2: 'Confirm'
    }
  },
  contact: { // 客服
    phone: 'Phone',
    email: 'E-mail'
  },
  remote: {
    crumbs: {
      L1: 'RemotePay',
      L2: 'Order List',
      L3: 'Generate Link',
    },
    panel: {
      title: 'Generate Link',
      shareGuide: 'Sharing Guidance'
    },
    form: {
      productName: 'Goods Name',
      quantity: 'Quantity',
      currency: 'Currency',
      hkd: 'HKD',
      price: 'Unit Price',
      add: 'Add',
      delete: 'Delete',
      totalAmount: 'Total Price',
      customerName: 'Customer Name',
      customerPhone: 'Customer Telephone',
      phone_font: `In order to ensure the safety of funds, it is recommended to enter the customer's phone number, so as not to be unable to contact the customer in case of financial problems.`,
      customerEmail: 'Customer Mailbox',
      paymentDeadline: 'Payment Closing Date',
      logisticsMode: {
        title: 'Logistics Mode',
        option1: 'Delivery or self-pick-up',
        option2: 'Delivery',
        option3: 'Self-pick-up',
        option4: 'No logistics'
      },
      date: 'Expected Delivery Time',
      description: 'Remarks',
      writeDescription: 'Please enter comments'
    },
    rules: {
      customerPhoneMessage: 'Please enter the correct format: area code-phone number',
      invalidEmail: 'Invalid email address',
      logisticsModeMsg: 'Please select logistics mode',
      quantityRules: 'Please input quantity',
      quantityFormat: 'Please enter numbers',
      unitPriceRules: 'Please input Unit price',
      productMessage: 'Please add Goods information',
      otherValidMessage: 'Do not enter special characters'
    },
    btn: {
      cancel: 'Cancel',
      link: 'Generate Link'
    }
  },
  remoteDone: {
    crumbs: {
      L1: 'RemotePay',
      L2: 'Link Management',
      L3: 'Generate Result'
    },
    panel: {
      title: 'Payment Link'
    },
    msg: {
      title: 'Payment Link',
      send: 'Send',
      cancel: 'Cancel',
      copy: 'Copy',
      confirm: 'Confirm',
      shareMessageLeft: 'Dear customer！The merchant',
      shareMessageRight: 'has sent you a purchase invitation, please pay in time, thank you! ',
      Email: 'Email',
      copyLink: 'Copy Link',
      promptEmail: 'Email address not filled in',
      promptMobile: 'The phone number is not filled in',
      copySuccess: 'copy successful',
      copyFail: 'copy failed',
      sent: 'Sent'
    },
    transaction: {
      title: 'Link Details'
    },
    table: {
      productName: 'Goods Name',
      quantity: 'Quantity',
      currency: 'Currency',
      price: 'Unit Price',
      totalAmount: 'Total Price',
      customerName: 'Customer Name',
      customerPhone: 'Customer Telephone',
      customerEmail: 'Customer Mailbox',
      paymentDeadline: 'Payment Closing Date',
      logisticsMode: 'Logistics Mode',
      date: 'Expected Delivery Time',
      description: 'Remarks'
    }
  },
  apply: {
    apply: 'Apply',
    applyed: 'Already Applied',
    title: 'What is remotepay',
    list1: 'Merchants create payment request links',
    list2: 'Merchants send links to customers using instant messaging.',
    list3: 'Customer payment',
    list4: 'Customers select shipping options (delivery / pick-up)',
    list5: 'Customers receive goods',
    howtoApply: 'How to apply for remotepay',
    method1: 'Submit an application',
    method2: 'Confirm the product contact email/phone.',
    method3: 'Create products',
    method4: 'Log in to the platform to use the product',
    remotePayMsg1: 'You can send the payment link to',
    remotePayMsg2: 'A',
    remotePayMsg3: 'nyone',
    remotePayMsg4: 'A',
    remotePayMsg5: 'nywhere',
    remotePayMsg7: 'A',
    remotePayMsg8: 'ny time',
    remotePayMsg9: 'and customers can make payment to complete their purchase.'
  },
  linkManage: {
    title: 'Link Management',
    filter: 'Filter',
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',
    sun: 'Sun',
    noData: 'No Link Data',
    btn: {
      oneMore: 'One More',
      cancel: 'Cancel',
      generateLinks: 'Generate Link',
      createLink: 'Create Link'
    },
    filterSe: {
      title: 'Filter',
      goodsName: 'Goods Name',
      createTime: 'Create Time',
      status: 'Status',
      creatorID: 'Creator ID',
      customerName: 'Customer Name',
      customerPhone: 'Customer Telephone',
      all: 'All',
      pending: 'Unpaid',
      canceled: 'Canceled',
      overdue: 'Overdue',
      Success: 'Success',
      fail: 'Fail',
      fullRefund: 'Full Refund',
      partialRefund: 'Partial Refund',
      confirm: 'Confirm',
      paymentFailed: 'Payment Failed',
      partialRefunded: 'Partial Refunded'
    },
    detail: {
      title: 'Detail',
      delete: 'Delete',
      linkId: 'Link ID:',
      link: 'Payment Link:',
      goodsName: 'Goods Name:',
      cId: 'Creator ID:',
      status: 'Status:',
      time: 'Create Time:',
      cancel: 'Cancel',
      oneMore: 'One More',
      paymentDeadline: 'Payment Closing Date:',
      confirmCancel: 'Confirm Cancel',
      confirmDelete: 'Confirm Deletion',
      deleteMsg: 'Are you sure you want to delete this link? After deleting, the link can no longer be paid and will not be displayed',
      cancelMsg: 'Are you sure you want to cancel this link? After cancellation, the link can no longer be paid'
    }
  },
  orderManage: {
    detail: 'Order Details',
    details: 'Details',
    title: 'Order Management',
    noData: 'No Order Data',
    delevery: 'Delivery',
    total: 'Total',
    unpaidAmount: 'Unpaid Amount',
    totalAmount: 'Total Amount',
    successAmount: 'Success Amount',
    failedAmount: 'Failed Amount',
    fullRefundAmount: 'Full Refund Amount',
    partialRefundAmount: 'Partial Refund Amount',
    number: 'Number',
    unpaidNumber: 'Unpaid Number',
    successNumber: 'Success Number',
    failedNumber: 'Failed Number',
    fullRefundNumber: 'Full Refund Number',
    partialRefundNumber: 'Partial Refund Number',
    entries: 'entries',
    confirmDelivery: 'Confirm Delivery',
    expressCompany: 'Express Company',
    expressNumber: 'Express Number',
    confirm: 'Confirm',
    cancel: 'Cancel',
    deliveryMsg: 'Are you sure you want to change the delivery status of this link to "delivered"? You can note the delivery company and express bill number below~',
    deliveFormat: 'Please input the express bill number in correct format',
    filter: {
      title: 'Filter',
      mchtOrderId: 'Merchant Order ID',
      payOrderId: 'Payment Order ID',
      linkId: 'Link ID',
      customerName: 'Customer Name',
      deliveryStatus: 'Delivery Status',
      noDelivery: 'No Delivery',
      notdelivered: 'Not Delivered',
      delivered: 'Delivered'
    }
  },
  orderEdit: {
    title: 'Order Editor',
    edit: 'Edit',
    productTitle: 'Product Information',
    buyerTitle: 'Buyer Information',
    expressTitle: 'Express Information',
    description: 'Remarks',
    customerAdress: 'Customer Address:',
    confirm: 'Confirm'
  },
  orderDetail: {
    title: 'Detail',
    mchtOrderId: 'Merchant Order ID',
    payOrderId: 'Payment Order ID',
    linkId: 'Link ID',
    transactionStatus: 'Order Status',
    paymentlink: 'Payment Link',
    createTime: 'Create Time',
    expectedDeliveryTime: 'Expected Delivery Time',
    productTitle: 'Product Information',
    quantity: 'Quantity',
    currency: 'Currency',
    hkd: 'HKD',
    price: 'Unit Price',
    totalAmount: 'Total Price',
    deliveryStatus: 'Delivery Status',
    buyerTitle: 'Buyer Information',
    customerName: 'Customer Name',
    customerPhone: 'Customer Telephone',
    customerEmail: 'Customer Mailbox',
    customerAdress: 'Customer Address',
    expressTitle: 'Express Information',
    logisticsMode: 'Logistics Mode',
    description: 'Remarks',
    expressCompany: 'Express Company',
    expressNumber: 'Express Number',
  },
  uploadMessage: {
    fileSize: 'Please upload pictures in jpg, png, jpeg format not exceeding 100M',
    uploadNow: 'Upload Now',
    uploadFail: 'upload failed'
  },
  overseaForget: {
    enterEmail: 'Please enter your email.',
    enterFullEmail: 'Input your full contact email address',
    emailAddr: 'Email Address',
    loginAccount: 'Account',
    enterAccount: 'Please enter your Account.',
    tryAnother: 'Try another way',
    next: 'Next',
    confirm: 'Confirm',
    notExist: 'E-mail address does not exist',
    sendCode: 'We will deliver a verification code to you. Please enter the code.',
    resend: 'Please resend',
    code: 'Verification Code',
    newPwd: 'New Password',
    enterCode: 'Please enter the code.',
    char: 'Please enter 6-20 characters',
    rePwd: 'Reset Password',
    invalidEmail: 'Invalid email address',
    text1: 'We will deliver a verification code to',
    text2: ' Please enter the code.',
    secend1: "Resend after( ",
    secend2: 's )',
    codeResent: 'Code Resent',
    wrongCode: 'Verification code is wrong',
    filledCode: 'Verification code must be filled',
    frequently: 'Get verification code frequently, please try again later',
    newManagementPassword: 'New Management Password',
    confirmManagementPassword: 'Confirm Management Password',
    msg: {
      m1: `You haven't set your contact email address yet.`,
      m2: 'Please contact our customer service team to set it first before you reset your management password.',
      m3: 'Please enter New Management Password',
      m4: 'Confirm new management password',
    },
  },
  firstlogin: {
    congratulation: 'Congratulation! You have registered at HaoJin Merchant App',
    changePwd: 'Please change your password to continue',
    newPwd: 'New Password',
    rePwd: 'Confirm Password',
    confirm: 'Confirm'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js